import 'select2/dist/js/select2.full.js'

jQuery('.member__sort select').select2({ width: '100%', placeholder: 'Sort By' })

jQuery('.award__sort select').select2({
    width       : '100%',
    placeholder : 'Choose Category'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown select').select2({
    width       : '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.ginput_container_select select').select2({ width: '100%' })


jQuery('.bbp_dropdown').select2({ width: '100%', minimumResultsForSearch: -1, outline:'none' })
